import {useContext} from 'react'

import PropTypes from 'prop-types'

import Collapsible from '@s-ui/react-collapsible-basic'
import Context from '@s-ui/react-context'
import ListTagcloud from '@s-ui/react-list-tagcloud'
import ChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown'

const IconChevronDown = () => <ChevronDown size="medium" aria-hidden role="presentation" />

const HEADING_TAGS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6'
}

const ListTagCloudItem = ({tags, title, linkFactory, headingTag: Heading = HEADING_TAGS.h4}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const hasTitle = Boolean(title)
  const tagCloudId = hasTitle ? `tagclouds-${title.replace(/ /g, '-')}` : 'tagclouds-default'

  return (
    <div className="mt-ListTagCloud">
      {hasTitle ? (
        <Collapsible
          icon={IconChevronDown}
          label={<Heading className="mt-ListTagCloud-title">{title}</Heading>}
          collapsed={isMobile}
          id={tagCloudId}
        >
          <ListTagcloud tags={tags} linkFactory={linkFactory} />
        </Collapsible>
      ) : (
        <ListTagcloud tags={tags} linkFactory={linkFactory} />
      )}
    </div>
  )
}

ListTagCloudItem.propTypes = {
  /**
   * Heading tag to use for the title
   */
  headingTag: PropTypes.oneOf(Object.values(HEADING_TAGS)),
  /**
   * List of tag objects
   */
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * tag text
       */
      label: PropTypes.string.isRequired,
      /**
       * URL for the tab link
       */
      link: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Factory used to create navigation links
   */
  linkFactory: PropTypes.func,
  /**
   * Optional string tagcloud title
   */
  title: PropTypes.string
}

export {HEADING_TAGS as listTagcloudHeadingTags}

export default ListTagCloudItem
